import { ProductType } from '@/product/constants/productTypes';

export const generateFiltersSetKey = (productType: ProductType | string) => `filters.${productType}.fields`;

interface SessionDriver {
  get(key: string): Promise<unknown>;
  set(key: string, value: unknown): Promise<unknown>;
  onKeyChange(key: string, callback: (value: unknown) => void): void;
}

/**
 * Stores settings data in a storage of different types (like Localstorage, Sessionstorage, API etc.)
 *
 * Settings scheme:
 * {
 *   "filters": {
 *     "rough": {},
 *     "diamond-colorless": {
 *       "fields": ["price", "carat", "cut],
 *       "predefined": [
 *         {
 *            "title": "Example 1",
 *            "fields": ["fluor", "carat", "seller"]
 *         }
 *       ]
 *     }
 *   },
 *   "ui": {
 *     "isSidebarOpened": false,
 *     "isHQModeEnabled": true
 *   }
 * }
 */
export default class UserSessionDataManager {
  driver!: SessionDriver;

  constructor(driver: SessionDriver) {
    this.setDriver(driver);
  }

  get<T = unknown>(key: string): Promise<T> {
    return this.driver.get(key) as Promise<T>;
  }

  set(key: string, data: unknown): Promise<unknown> {
    return this.driver.set(key, data);
  }

  onKeyChange<T = unknown>(key: string, callback: (value: T) => void) {
    this.driver.onKeyChange(key, callback as (value: unknown) => void);
  }

  setDriver(driver: SessionDriver) {
    this.driver = driver;
  }
}
